import React from "react";
import Button from "../../global/Button";
import { toggleOBPDrawer } from "../../obp";

export default function LocationDetails({ location }) {
  let image, description, openingHours;

  if (location.image) {
    const imageURL = new URL(location.image, window.location.href);
    imageURL.searchParams.append("width", 450);
    image = (
      <img src={imageURL.toString()} className="location-details__image" />
    );
  }

  if (location.description) {
    description = (
      <div
        className="location-details__description font-body-md"
        dangerouslySetInnerHTML={{ __html: location.description }}
      ></div>
    );
  }

  if (location.openingHours) {
    openingHours = (
      <div className="location-details__hours">
        <h4 className="h-lg-sans h--no-margin">Opening Hours</h4>
        <div
          className="location-details__hours-content font-body-md"
          dangerouslySetInnerHTML={{ __html: location.openingHours }}
        ></div>
      </div>
    );
  }

  return (
    <div className="location-details">
      <div className="location-details__inner">
        {image}
        {description}
        {openingHours}
        <div className="location__obp">
          <Button
            title="Reward your therapist"
            onClick={() => toggleOBPDrawer(location)}
          />
        </div>
      </div>
    </div>
  );
}
